/* eslint-disable react/destructuring-assignment */
import React from 'react';

import { Flex } from '@chakra-ui/react';
import { components } from 'react-select';
import { VisibilityIconPack } from 'screens/home/addPost/AddPostModal/SelectVisibility';

import { Check } from 'assets/assetsV1/iconComponents';

import {
  FEEDBACK_FORM_VISIBILITY_RABBIT,
  FEEDBACK_FORM_VISIBILITY_RABBIT_WITHOUT_PUBLIC,
} from 'constants/ProjectConstants';

import { SelectDashed } from 'uiToolkitV1/Select';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

interface Props {
  selectedValue: string;
  onChange: (value: string) => void;
  isDisabled?: boolean;
  showLabel?: boolean;
  isSharePublicPraise?: boolean;
}

const IconOption = (props) => {
  const { Option } = components;

  const selected = props.getValue()[0];

  return (
    <Option {...props}>
      <Flex alignItems="center">
        {VisibilityIconPack[props.data.icon]}
        <TextBodyMedium>{props.data.label}</TextBodyMedium>
        {selected?.value === props.data.value && <Check ml="auto" color="button.blue.focus" />}
      </Flex>
    </Option>
  );
};

const SingleValueIcon = (props) => {
  const { SingleValue } = components;
  return (
    <SingleValue {...props}>
      <Flex alignItems="center">
        {VisibilityIconPack[props.data.icon]}
        <TextBodyMedium>{props.data.label}</TextBodyMedium>
      </Flex>
    </SingleValue>
  );
};

const FeedbackVisibilityDropdown = ({
  onChange,
  selectedValue,
  isDisabled = false,
  showLabel = true,
  isSharePublicPraise = false,
}: Props) => {
  const selectedOption = FEEDBACK_FORM_VISIBILITY_RABBIT.find((option) => option.value === selectedValue);

  const handleChange = (value) => {
    onChange(value);
  };

  return (
    <Flex alignItems="center" className="feedback-visibility">
      {showLabel && (
        <TextLabel mr="8px" color="text.g2">
          Visibility:
        </TextLabel>
      )}
      {/* @ts-ignore */}
      <SelectDashed
        value={selectedOption}
        options={isSharePublicPraise ? FEEDBACK_FORM_VISIBILITY_RABBIT : FEEDBACK_FORM_VISIBILITY_RABBIT_WITHOUT_PUBLIC}
        handleChange={handleChange}
        components={{ Option: IconOption, SingleValue: SingleValueIcon }}
        isDisabled={isDisabled}
        width="210px"
      />
    </Flex>
  );
};

export default FeedbackVisibilityDropdown;
